import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';

import {FuseSharedModule} from '@fuse/shared.module';
import {CustomPromptFooterComponent} from './custom-prompt-footer.component';

@NgModule({
    declarations: [
        CustomPromptFooterComponent
    ],
    imports: [
        RouterModule,

        MatButtonModule,
        MatIconModule,
        MatToolbarModule,

        FuseSharedModule
    ],
    exports: [
        CustomPromptFooterComponent
    ]
})
export class FooterModule {
}
